import { useCallback, useEffect, useState } from 'react';

/** Per-user Live Map preference: keep the camera on the selected vehicle /
 *  person as new fixes arrive (default, today's behaviour) or only fly to it
 *  once when the selection changes. Same localStorage pattern as Animate. */
export const LS_KEY = 'trackizy_livemap_follow_selection';

export function useLiveMapFollow() {
  const [enabled, setEnabled] = useState(() => {
    try { const v = localStorage.getItem(LS_KEY); return v == null ? true : v === 'true'; } catch { return true; }
  });
  useEffect(() => {
    try { localStorage.setItem(LS_KEY, String(enabled)); } catch { /* private-mode safari etc. */ }
  }, [enabled]);
  const toggle = useCallback(() => setEnabled((p) => !p), []);
  return [enabled, toggle];
}
